import { LinkRounded } from "@mui-symbols-material/w300"
import type { ReactElement } from "react"

import { Button } from "@/components/common/Button"

const AssociateProductButton = ({ onClick }: { onClick: () => void }): ReactElement => {
  return (
    <Button size='small' appearance='outlined' onClick={onClick}>
      <LinkRounded />
      Associate Products
    </Button>
  )
}

export default AssociateProductButton
